import type { ClientFormValues } from '../models/Forms';

const identityDocumentRegistryIdentificationTypes = new Set(['PASSPORT', 'PERSONAL_ID']);

export function normalizeIdentityDocumentNumber(value: string) {
  return value.replaceAll(/\s+/g, '').trim().toUpperCase();
}

export function shouldRunIdentityDocumentValidation(values: ClientFormValues) {
  if (!identityDocumentRegistryIdentificationTypes.has(values.identification)) {
    return false;
  }
  return normalizeIdentityDocumentNumber(values.identificationNumber).length > 0;
}

export function getIdentityDocumentValidationFingerprint(values: ClientFormValues) {
  return `${values.identification}|${normalizeIdentityDocumentNumber(values.identificationNumber)}`;
}
